/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { ChannelPsp } from "./ChannelPsp";
import * as t from "io-ts";

// required attributes
const ChannelPspListR = t.interface({
  page_info: PageInfo,

  payment_service_providers: t.readonlyArray(ChannelPsp, "array of ChannelPsp")
});

// optional attributes
const ChannelPspListO = t.partial({});

export const ChannelPspList = t.intersection(
  [ChannelPspListR, ChannelPspListO],
  "ChannelPspList"
);

export type ChannelPspList = t.TypeOf<typeof ChannelPspList>;
